import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import SemicircularChart from "../../../common/AnalyticsComponents/SemicircularChart";
import PriorityBreakdown from "../../../common/AnalyticsComponents/PriorityBreakdown";
import StatusBadgeRow from "../../../common/AnalyticsComponents/StatusBadgeRow";
import { approvalAnalyticsContentEnum } from "../../../utils/constant";
import { useTranslation } from "react-i18next";

const ApprovalAnalytics = ({ isSideBarOpen, isTopicOpen }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const approvalAnalyticsData = useSelector(
    (state) => state?.arkchatgroup?.approvalAnalyticsData?.analyticsData
  );
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          // 3 cols when sidebar + topics panel are both open (narrower viewport)
          md: isSideBarOpen && isTopicOpen ? "repeat(3, 1fr)" : "repeat(4, 1fr)",
        },
        gap: "0.75rem",
        mt: "0.1rem",
      }}
    >
      {approvalAnalyticsData?.map((data) => (
        <Box
          sx={{
            borderRadius: "8px",
            border: "1px solid rgba(232, 232, 232, 1)",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
            padding: "0.75rem 0.8rem 0.85rem",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
          }}
          key={data?.status + "approvalAnalyticsData"}
        >
          {/* Card title */}
          <Typography
            textAlign={"center"}
            fontWeight={700}
            fontSize={"0.92rem"}
            color={"#111"}
            mb={"0.3rem"}
          >
            {approvalAnalyticsContentEnum[data?.status]?.title}
          </Typography>

          {/* Radial donut chart */}
          <SemicircularChart
            trackBackground={
              approvalAnalyticsContentEnum[data?.status]?.backgroundColor
            }
            colorsData={approvalAnalyticsContentEnum[data?.status]?.color}
            seriesData={
              data?.total !== 0
                ? Math.floor((data?.count / data?.total) * 100)
                : 0
            }
            centerLabel={data?.status === "total" ? data?.count : undefined}
          />

          {/* On Time / After Delay badges — below the chart */}
          {(data?.status === "done" || data?.status === "rejected") && (
            <StatusBadgeRow
              badges={[
                { label: "On Time", value: data?.onTime ?? 0 },
                { label: "After Delay", value: data?.afterDelay ?? 0 },
              ]}
            />
          )}

          {/* Priority label + bars */}
          <Typography
            textAlign={"center"}
            fontSize={"0.78rem"}
            color={"#888"}
            mt={"0"}
            mb={"0.4rem"}
          >
            {appContent?.KEY190 || "Priority"}
          </Typography>
          <PriorityBreakdown priority={data?.priority} />
        </Box>
      ))}
    </Box>
  );
};

export default ApprovalAnalytics;
